<template>
  <div>
    <div v-if="!screenprotectortype" class="text-center">
      <b-spinner></b-spinner>
    </div>
    <div v-else>
      <app-header :title="screenprotectortype.name" :subtitle="'Screen Protector Type #' + screenprotectortype.id">
        <b-button v-router-link="{name:'screenprotectortype-editor',query:{id:screenprotectortype.id}}" variant="primary">
          <i class="fa fa-pencil-square-o" style="font-size:20px" /> Edit Screen Protector Type
        </b-button>
      </app-header>
      <b-container>
        <b-tabs>
        
          <b-tab title="Profile" fade show active class="mt-3">
            <b-card-group columns>
              <!--description-->
              <b-card no-body>
                <b-card-header>
                  Description
                </b-card-header>
                <b-card-body>
                  {{ screenprotectortype.description }}
                </b-card-body>
              </b-card>
              <!--settings-->
              <b-card no-body>
                <b-card-header>
                  Settings
                </b-card-header>
                <b-table-simple>
                  <b-tr>
                    <b-td>Icon</b-td>
                    <b-td class="text-right">
                      {{ screenprotectortype.icon }}
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-td>Created</b-td>
                    <b-td class="text-right">
                      {{ screenprotectortype.created | moment("YYYY-MM-DD") }}
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-td>Updated</b-td>
                    <b-td class="text-right">
                      {{ screenprotectortype.updated | moment("YYYY-MM-DD") }}
                    </b-td>
                  </b-tr>
                </b-table-simple>
              </b-card>
            </b-card-group>
          </b-tab>
        
        </b-tabs>
      </b-container>
    </div>
  </div>
</template>

<script>
import $api from '@/services/api';
import AppHeader from '@/components/AppHeader';

export default {
  components: {
    AppHeader,
  },

  data() {
    return {
      query: '',
      screenprotectortype: null,
    };
  },

  created() {
    this.refreshData();
  },

  methods: {
    refreshData() {
      const screenprotectortypeId = this.$route.params.id;
      $api.get(`/v1/internal/screenprotectortypes/${screenprotectortypeId}`).then((screenprotectortype) => {
        this.screenprotectortype = screenprotectortype;
      });
    },
  },
};
</script>
